//=====================================================
//　G003カレンダー週Header
//=====================================================
import { Weather } from "../../utils/ConstCommon";
import { G003CalendarControl } from "./G003CalendarControl";

interface IFProps {
    apiData: any,
    refElm: React.RefObject<HTMLDivElement>,
    tblHeaderWidth: number,
    hoverCellIdx: number,
    tblHeaderFixed: boolean,
    loadingDone:boolean,
}
export function G003CalendarWeeklyHeader(props: IFProps){

    //APIデータがない場合は処理無し
    if (!props.apiData) {
        return null;
    }

    //APIデータ整形
    const weeklyHeaders = getWeeklyHeaders(props.apiData);

    //ヘッダーDIV用クラス
    let headerDivClass = "calendar-header";
    if (props.tblHeaderFixed) {
        headerDivClass = headerDivClass + " is-fixed";
    }
    // mapのfunction内で<></> を記述すると、リロード後の初回表示時に下記警告が発生する。
    //  Warning: Each child in a list should have a unique "key" prop.
    //  Check the render method of G003CalendarWeeklyHeader. 
    //  See https://reactjs.org/link/warning-keys for more information.
    // props.loadingDone の条件分岐をJSX内に記述する場合、
    // mapのfunction内で<></>を記述することになるので
    // props.loadingDone の条件分岐はif文で記述する。
    if(props.loadingDone){
        return (
            <div className={headerDivClass} ref={props.refElm} >
                <G003CalendarControl period={props.apiData.period} />
                <table className="calendar" style={{width: props.tblHeaderWidth}}>
                    <tbody>
                        <tr>
                        <th></th>
                        {weeklyHeaders.map(function(val, idx){
                            return (
                                <th key={idx} className={props.hoverCellIdx === idx ? "is-hover" : ""} >
                                    <div key={idx} className="calendar-date">
                                        <span className="calendar-date-day text-multiline">{val.date}</span>
                                        {val.weather !== -1 &&
                                            <span className={"calendar-date-weather " + Weather[val.weather]}></span>
                                        }
                                    </div>
                                </th>
                            )
                        })}
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }else{
        return (
            <div className={headerDivClass} ref={props.refElm} >
                <G003CalendarControl period={props.apiData.period} />
                <table className="calendar" style={{width: props.tblHeaderWidth}}>
                    <tbody>
                        <tr>
                        <th style ={{border:0,borderColor:"#fff"}} ></th>
                        {weeklyHeaders.map(function(val, idx){
                            return (
                                <th key={idx} style ={{border:0,borderColor:"#fff"}} ></th>
                            )
                        })}
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

//-----------------------------------------------------
//　週Header取得
//-----------------------------------------------------
interface IFWeeklyHeader {
    date: string,
    weather: number,
    active: boolean,
}
function getWeeklyHeaders(apiData:any){
    
    let weeklyHeaders:IFWeeklyHeader[] = [];

    apiData.frames.forEach(function(val:any){

        let tmpWeeklyHeader:IFWeeklyHeader = {date:"", weather:-1, active: true};
        //日付
        tmpWeeklyHeader.date = val.date.replace(" ", "\n");
        //曜日
        if (val.frames.weather !== ""){
            tmpWeeklyHeader.weather = Number(val.weather);
        }
        weeklyHeaders.push(tmpWeeklyHeader);

    });

    return weeklyHeaders;

}